var spoiler_default = {
  "fontElementMap": "MxbeI",
  "hideText": "POFkj",
  "onHoverText": "F7u-v",
  "hideBlock": "_292Ii",
  "smallBlur": "_9i7E-",
  "mediumBlur": "cpW5c",
  "largeBlur": "i927P",
  "hideBlock_gallery": "hRzTT",
  "overlay": "esocp",
  "overlay_gallery": "BBfpM",
  "revealSpoilerBtn": "XPUAb",
  "isMobile": "QLiRT",
  "onHoverBtn": "jXBN6",
  "spoilerWrapper": "pgxTl",
  "spoilerDescription": "hwzIH",
  "spoilerContainer": "SbGh8",
  "spoilerContainer_Gallery": "_4Pkmr"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
